export default __webpack_public_path__ + "assets/fc2a1d5349416f88770f3f2141096ad8.png";